import { render } from "./list-management-modal.vue?vue&type=template&id=a1a25fbc&ts=true"
import script from "./list-management-modal.vue?vue&type=script&lang=ts"
export * from "./list-management-modal.vue?vue&type=script&lang=ts"

import "./list-management-modal.vue?vue&type=style&index=0&id=a1a25fbc&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__